/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* istanbul ignore file */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.ExerciseMyPrivacyRights = (await import('./pages/privacy/ExerciseMyPrivacyRights')).ExerciseMyPrivacyRights;
    Components.PrivacyReports = (await import('./pages/privacy/PrivacyRightsReports/Privacy-Reports')).PrivacyReports;
    Components.PrivacyStatementHOC = (await import('./pages/privacy/PrivacyStatement/PrivacyStatementHOC')).PrivacyStatementHOC;
    Components.MyPreferenceCenterHOC = (await import('./pages/epc/MyPreferenceCenterHOC')).MyPreferenceCenterHOC;
    Components.PrivacyOverview = (await import('./pages/privacy/PrivacyOverview/Privacy-Overview')).PrivacyOverview;
    Components.Home = (await import('./pages/privacy/Home')).Home;
    Components.FraudCenter = (await import('./pages/privacy/FraudCenter')).FraudCenter;
    Components.SupplyChainPrivacyPolicy = (await import('./pages/privacy/SupplyChainPrivacyPolicy')).SupplyChainPrivacyPolicy;
    Components.ThirdPartyDisclosureRoute = (await import('./pages/privacy/ThirdPartyDisclosure/ThirdPartyDisclosureRoute')).ThirdPartyDisclosureRoute;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  exerciseMyPrivacyRightsOld: {
    name: 'ExerciseMyPrivacyRights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import('./pages/privacy/ExerciseMyPrivacyRights'),
    get component() {
      return ssr
        ? serverPages.ExerciseMyPrivacyRights
        : currentRouteName === 'ExerciseMyPrivacyRights'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise_My_Privacy_Rights',
    channel: null
  },
  californiaPrivacyRightsOld: {
    name: 'PrivacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import('./pages/privacy/PrivacyRightsReports/Privacy-Reports'),
    get component() {
      return ssr
        ? serverPages.PrivacyReports
        : currentRouteName === 'PrivacyReports'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California_Privacy_Rights',
    channel: null
  },
  exerciseMyPrivacyRights: {
    name: 'ExerciseMyPrivacyRights',
    componentName: 'ExerciseMyPrivacyRights',
    chunk: () => import('./pages/privacy/ExerciseMyPrivacyRights'),
    get component() {
      return ssr
        ? serverPages.ExerciseMyPrivacyRights
        : currentRouteName === 'ExerciseMyPrivacyRights'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ExerciseMyPrivacyRights })));
    },
    path: '/:context?/privacy/Exercise-My-Privacy-Rights',
    channel: null
  },
  privacySecurity: {
    name: 'PrivacyStatementHOC',
    componentName: 'PrivacyStatementHOC',
    chunk: () => import('./pages/privacy/PrivacyStatement/PrivacyStatementHOC'),
    get component() {
      return ssr
        ? serverPages.PrivacyStatementHOC
        : currentRouteName === 'PrivacyStatementHOC'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyStatementHOC })));
    },
    path: '/:context?/privacy/Privacy-Security',
    channel: null
  },
  californiaPrivacyRights: {
    name: 'PrivacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import('./pages/privacy/PrivacyRightsReports/Privacy-Reports'),
    get component() {
      return ssr
        ? serverPages.PrivacyReports
        : currentRouteName === 'PrivacyReports'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California-Privacy-Rights',
    channel: null
  },
  myPreferenceCenter: {
    name: 'MyPreferenceCenterHOC',
    componentName: 'MyPreferenceCenterHOC',
    chunk: () => import('./pages/epc/MyPreferenceCenterHOC'),
    get component() {
      return ssr
        ? serverPages.MyPreferenceCenterHOC
        : currentRouteName === 'MyPreferenceCenterHOC'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.MyPreferenceCenterHOC })));
    },
    path: '/:context?/privacy/MyPreferenceCenter',
    channel: null
  },
  privacyOverview: {
    name: 'PrivacyOverview',
    componentName: 'PrivacyOverview',
    chunk: () => import('./pages/privacy/PrivacyOverview/Privacy-Overview'),
    get component() {
      return ssr
        ? serverPages.PrivacyOverview
        : currentRouteName === 'PrivacyOverview'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyOverview })));
    },
    path: '/:context?/privacy/privacy-and-security-at-a-glance',
    channel: null
  },
  privacyStatement: {
    name: 'PrivacyStatementHOC',
    componentName: 'PrivacyStatementHOC',
    chunk: () => import('./pages/privacy/PrivacyStatement/PrivacyStatementHOC'),
    get component() {
      return ssr
        ? serverPages.PrivacyStatementHOC
        : currentRouteName === 'PrivacyStatementHOC'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyStatementHOC })));
    },
    path: '/:context?/privacy/privacy-and-security-statement',
    channel: null
  },
  privacyHome: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/privacy/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/privacy/overview',
    channel: null
  },
  privacyReports: {
    name: 'PrivacyReports',
    componentName: 'PrivacyReports',
    chunk: () => import('./pages/privacy/PrivacyRightsReports/Privacy-Reports'),
    get component() {
      return ssr
        ? serverPages.PrivacyReports
        : currentRouteName === 'PrivacyReports'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PrivacyReports })));
    },
    path: '/:context?/privacy/California-Privacy-Rights-and-Report',
    channel: null
  },
  fraudCenter: {
    name: 'FraudCenter',
    componentName: 'FraudCenter',
    chunk: () => import('./pages/privacy/FraudCenter'),
    get component() {
      return ssr
        ? serverPages.FraudCenter
        : currentRouteName === 'FraudCenter'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.FraudCenter })));
    },
    path: '/:context?/privacy/Fraud-Center',
    channel: null
  },
  supplyChainPrivacyPolicy: {
    name: 'SupplyChainPrivacyPolicy',
    componentName: 'SupplyChainPrivacyPolicy',
    chunk: () => import('./pages/privacy/SupplyChainPrivacyPolicy'),
    get component() {
      return ssr
        ? serverPages.SupplyChainPrivacyPolicy
        : currentRouteName === 'SupplyChainPrivacyPolicy'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SupplyChainPrivacyPolicy })));
    },
    path: '/:context?/privacy/driver-handheld-app-privacy-statement',
    channel: null
  },
  thirdPartyDisclosure: {
    name: 'ThirdPartyDisclosureRoute',
    componentName: 'ThirdPartyDisclosureRoute',
    chunk: () => import('./pages/privacy/ThirdPartyDisclosure/ThirdPartyDisclosureRoute'),
    get component() {
      return ssr
        ? serverPages.ThirdPartyDisclosureRoute
        : currentRouteName === 'ThirdPartyDisclosureRoute'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThirdPartyDisclosureRoute })));
    },
    path: '/:context?/privacy/third-party-disclosure-list',
    channel: null
  }
});
